import {
  _getPackageList,
  _getUnitType,
  _getPmsList,
  _createEditPms
} from '@/api/Permission'
import {
  catchErr
} from '@/utils/utils'
import {
  Message
} from 'element-ui'
// import router from '@/router'


export default {
  // 搜索列表数据
  async getTableList_A({
    commit,
    state
  }) {
    let searchData = state.searchData;
    let params = {};
    if(searchData.dateRange != null && searchData.dateRange.length >= 2) {
      params.createDateStart = searchData.dateRange[0];
      params.createDateEnd = searchData.dateRange[1];
    }
    if(searchData.name != "") {
      params.name = searchData.name;
    }
    if(searchData.remarks != "") {
      params.remarks = searchData.remarks;
    }
    let pageData = state.pageData;

    let [err, res] = await catchErr(_getPackageList({
      data: params,
      pageInfo: pageData
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      let resData = res.data;
      let resPage = res.pageInfo;
      commit("SETOPTIONS", {
        pageData: resPage,
        tableData: resData
      })
    }
    return;
  },
  // 获取单位类型
  async getUnitType_A({
    commit,
    state
  }) {
    let [err, res] = await catchErr(_getUnitType());
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      let resData = res.data;
      resData.forEach(item => {
        item.id = item.id.toString()
      })
      commit("SETOPTIONS", {
        arrUnitTypes: resData
      })
    }
    return true;
  },
  // 获取具体权限列表
  async getPmsList_A({
    commit,
    state
  }, id = 0) {
    let [err, res] = await catchErr(_getPmsList({
      data: id
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      let resData = res.data;

      resData.menus.forEach(item => {
        item.arrLevel0 = [];
        item.arrSubPms = [];
        item.childrenSelected = [];
        item.childrenSelectedAll = true;

        let children = item.children;

        for (let i = children.length - 1; i >= 0; i--) {
          let pms_child = children[i];
          if (pms_child.level === 0) {
            let pms_child_level0 = children.splice(i, 1)[0];
            pms_child_level0.selected = "";
            pms_child_level0.children.forEach(itemLevel0Child => {
              if (itemLevel0Child.check) {
                pms_child_level0.selected = itemLevel0Child.id;
              }
            })
            //外部权限
            item.arrLevel0.unshift(pms_child_level0)
          } else if (pms_child.children && pms_child.children.length > 0) {
            // 下级-下下级权限（详情）
            let subChild = children.splice(i, 1)[0];
            subChild.childrenSelected = [];
            subChild.childrenSelectedAll = true;
            for (let j = 0; j < subChild.children.length; j++) {
              let pms_subChild = subChild.children[j];
              if (pms_subChild.check) {
                subChild.childrenSelected.push(pms_subChild.id);
              } else {
                subChild.childrenSelectedAll = false;
              }
            }
            item.arrSubPms.push(subChild)
          } else {
            // 下级权限
            if (pms_child.check) {
              item.childrenSelected.push(pms_child.id);
            } else {
              item.childrenSelectedAll = false;
            }
          }
        }
      })
      let createData = state.createData;
      createData.menus = resData.menus;
      
      if(id != 0) {
        createData.typeState = resData.typeState;
      }
    }
    return;
  },

  // 新建、编辑岗位
  async createEditPms_A({
    commit,
    state
  }) {
    let createData = state.createData;
    let pmsStr = getPmsStr(createData);
    if (pmsStr.length === 0) {
      Message.error("请给该岗位配置权限")
      return
    }

    let params = {
      "name": createData.name,
      "type": createData.types.join(","),
      "remarks": createData.remarks,
      "menuIds": pmsStr
    }
    if (createData.id) {
      params.id = createData.id
    }

    let [err, res] = await catchErr(_createEditPms({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status === 1000) {
        if (createData.id) {
          Message.success("编辑成功")
        } else {
          Message.success("创建成功")
        }
        return true

      } else if (res.status === 1200) {
        Message.error("岗位名称重复")
      }
    }
    return;
  },


}

function getPmsStr(createData) {
  let result = "";
  let arrMenu = createData.menus;
  arrMenu.forEach(item => {
    // 页面权限
    if (item.check == true) {
      result = result + `${item.id},`

      // level0 
      if (item.arrLevel0.length > 0) {
        item.arrLevel0.forEach(itemLevel0 => {
          if (itemLevel0.selected !== "") {
            result = result + `${itemLevel0.id},${itemLevel0.selected},`
          }
        })
      }

      // 操作
      item.childrenSelected.forEach(childId => {
        result = result + `${childId},`
      })

      //下级（详情）
      if (item.arrSubPms.length > 0) {
        item.arrSubPms.forEach(itemSubPms => {
          if (itemSubPms.check) {
            result = result + `${itemSubPms.id},`

            itemSubPms.childrenSelected.forEach(subChildId => {
              result = result + `${subChildId},`
            })

          }
        })
      }

    }
  })
  if (result.length > 0) {
    result = result.substring(0, result.length - 1)
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/store/modules/Permission/actions.js